import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBdo_0JuG2Xlr-oj59nUWM3re4swTXqA4c",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "cosmk-vault.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "cosmk-vault",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "cosmk-vault.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "512710721087",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:512710721087:web:6b3132d43abd6a6646828a",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-2B5WG4ZWGG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}
export { analytics };

console.log('✅ Firebase initialized with configuration:', {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  usingEnvVars: !!import.meta.env.VITE_FIREBASE_PROJECT_ID
});

export default app; 